import React from 'react';
import ViewList from '@mui/icons-material/ViewList';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import DocumentTemplateSignatureBookmarkOptionListComponent from './DocumentTemplateSignatureBookmarkOptionListComponent';

const DocumentTemplateSignatureBookmarkOptionListCard = ({
  documentTemplate,
  onSave,
  validation,
  optionSources,
  buttonsDisabled,
  onAddNewOptionBookmark,
  onOptionBookmarkPropertyChanged,
  onLookupOptionBookmarkPropertyChanged,
  onOptionBookmarkDeleted
}) => {
  const [t] = useTranslation();

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('DocumentTemplate.OptionsBookmarks')}
      actions={
        <>
          <IconButton color='transparent' fontSize='medium' type='add' tooltip={t('Tooltips.Add')} onClick={onAddNewOptionBookmark} />
          <IconButton
            color='transparent'
            fontSize='medium'
            type='save'
            tooltip={t('DocumentTemplate.SaveChanges')}
            onClick={onSave}
            disabled={buttonsDisabled}
          />
        </>
      }
    >
      <>
        <Prompt
          when={documentTemplate.documentTemplateXOptionBookmarksChanged}
          message={t('DocumentTemplate.LeavingWithoutSavingBookmarks')}
        />
        <DocumentTemplateSignatureBookmarkOptionListComponent
          documentTemplate={documentTemplate}
          validation={validation}
          optionSources={optionSources}
          onOptionBookmarkPropertyChanged={onOptionBookmarkPropertyChanged}
          onLookupOptionBookmarkPropertyChanged={onLookupOptionBookmarkPropertyChanged}
          onOptionBookmarkDeleted={onOptionBookmarkDeleted}
        />
      </>
    </Card>
  );
};

DocumentTemplateSignatureBookmarkOptionListCard.propTypes = {
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  documentTemplate: PropTypes.object.isRequired,
  optionSources: PropTypes.array,
  buttonsDisabled: PropTypes.bool.isRequired,
  onAddNewOptionBookmark: PropTypes.func.isRequired,
  onOptionBookmarkPropertyChanged: PropTypes.func.isRequired,
  onLookupOptionBookmarkPropertyChanged: PropTypes.func.isRequired,
  onOptionBookmarkDeleted: PropTypes.func.isRequired
};

export default DocumentTemplateSignatureBookmarkOptionListCard;
